import { render, staticRenderFns } from "./LiveRecent.vue?vue&type=template&id=64461601&lang=pug"
import script from "./LiveRecent.vue?vue&type=script&lang=ts"
export * from "./LiveRecent.vue?vue&type=script&lang=ts"
import style0 from "./LiveRecent.vue?vue&type=style&index=0&id=64461601&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports